import * as vp from 'vopay';
import React from 'react';
import UserDropDown from './UserDropDown/UserDropDown';
import { usePartnerData } from '../../providers/PartnerData.provider';

const { Box, NavTop } = vp;

const DashboardNavTop = (): React.JSX.Element => {
  const { response } = usePartnerData();

  return (
    <NavTop>
      <Box jc="fe" ai="center" gap="sm">
        {' '}
        <div>{`${response.username} (${response.accountId})`}</div>
        <div className="dropdownContainer">
          <UserDropDown />
        </div>
      </Box>
    </NavTop>
  );
};

export default DashboardNavTop;
